import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-initial",
    templateUrl: "./go-initial.component.html"
})


export class GoInitialComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;

    constructor() {
        super(GO_COMPONENTS.INITIAL);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-initial/go-initial.component.ts